<template>
  <div class="modal">
    <div class="modal-content" ref="modalBox" :style="custom">
    </div>
  </div>
</template>

<script>
import lottie from "lottie-web";

export default {
  props: {
    data: {
      type: Object,
      default: {}
    },
    speed: {
      type: Number,
      default: 1
    },
    custom: {
      type: Object,
      default: null
    }
  },
  mounted() {
    this.loadAnimation();
  },
  methods: {
    loadAnimation() {
      this.saveAnimation = lottie.loadAnimation({
        container: this.$refs.modalBox, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: this.data // the path to the animation json
      });
      this.saveAnimation.setSpeed(this.speed);
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.6);
}

  /* Modal Content */

.modal-content {
  z-index: 20;
  width: 5%;
  display: flex;
  position: fixed;
  top: 30%;
  left: 48%;
}
</style>
